/**
 * Premium Managed Hiring: whether a role is worked by our recruiters or by the employer.
 *
 * Shared because two screens set it -- the job workspace's "Managed hiring" card and the job
 * create form -- and a list of enum values written twice drifts the first time one gains a value.
 */

/** Stored on `Job.hiringMode`. Do not localise the values; only the labels. */
export const HIRING_MODE_OPTIONS = [
  { value: 'SELF_SERVE', label: 'Self-serve (employer works it)' },
  { value: 'MANAGED', label: 'Premium Hiring (our recruiters work it)' },
];

export const MANAGED = 'MANAGED';

/**
 * The warning a MANAGED role with no recruiter deserves.
 *
 * Not a nag. The application access rule is `hiringMode != MANAGED OR assignedHrId == me`, so this
 * exact pair hides the job's candidates from every HR and leaves them visible only to Super
 * Admins. Nothing else on screen connects that outcome to this control, and it surfaces later as
 * "the applications disappeared".
 */
export const MANAGED_WITHOUT_RECRUITER_WARNING =
  "Premium Hiring with no recruiter: this job's applicants are hidden from every HR until one is " +
  'assigned. Super Admins can still see them.';
